// firebase.js
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

// ✅ Firebase config
const firebaseConfig = {
  apiKey: "AIzaSyAtpO96gGrJ6PHYQPAa1XlVEp7kjMGeA6A",
  authDomain: "faststyle-f63a1.firebaseapp.com",
  projectId: "faststyle-f63a1",
  storageBucket: "faststyle-f63a1.appspot.com",
  messagingSenderId: "200647176505",
  appId: "1:200647176505:web:645def56921617af94f8e8",
  measurementId: "G-D4R7EKKQ0X"
};

// ✅ Initialize Firebase
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const db = getFirestore(app);

export { app, auth, db }; // ✅ Make sure this line exists
